import axios from 'lib/axios';

import {
  COUNCIL_ERROR,
  COUNCILS_ERROR,
  COUNCIL_LOADING,
  COUNCIL_RECEIVED,
  COUNCILS_LOADING,
  COUNCILS_RECEIVED
} from 'constants/actions';

import {
  E_COUNCIL_UNKNOWN,
  E_COUNCILS_UNKNOWN,
  E_COUNCIL_NOT_FOUND,
  E_COUNCILS_NOT_FOUND
} from 'constants/errors';

import { dispatcher } from 'lib/redux';

export const fetchCouncils = () => async () => {
  dispatcher(COUNCILS_LOADING, true);

  try {
    var response = await axios.get('councils');

    dispatcher(COUNCILS_LOADING, false);
    dispatcher(COUNCILS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(COUNCILS_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(COUNCILS_ERROR, E_COUNCILS_NOT_FOUND);
    }

    dispatcher(COUNCILS_ERROR, E_COUNCILS_UNKNOWN);
  }
};

export const fetchCouncil = (councilId) => async () => {
  dispatcher(COUNCIL_LOADING, true);

  try {
    var response = await axios.get(`councils/${councilId}`);

    dispatcher(COUNCIL_LOADING, false);
    dispatcher(COUNCIL_RECEIVED, response.data);
  } catch (e) {
    dispatcher(COUNCIL_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(COUNCIL_ERROR, E_COUNCIL_NOT_FOUND);
    }

    dispatcher(COUNCIL_ERROR, E_COUNCIL_UNKNOWN);
  }
};
